import { Route, Routes as RoutesContainer } from 'react-router';
import { Print } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/rank/print' element={<Print />} />
    </RoutesContainer>
  );
};
export default Routes;
